import { Component, HostListener, OnDestroy, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { LookupComponent } from '../tools/lookup/lookup.component';
import { AnalyticsService } from '../services/analytics.service';

/**
 * Floating Lookup button, stacked above the support-assistant bubble. Opens
 * the Lookup tool (venue + user search) in a side panel so it is reachable
 * from any page without leaving the current one. Mounted once in
 * MainComponent, inside the super-admin login gate.
 *
 * Any router navigation (e.g. "View Full Details" inside the panel) closes it.
 */
@Component({
  selector: 'app-lookup-button',
  imports: [LookupComponent],
  templateUrl: './lookup-button.component.html',
})
export class LookupButtonComponent implements OnDestroy {
  private router = inject(Router);
  private analytics = inject(AnalyticsService);

  readonly isOpen = signal(false);

  private navSub: Subscription = this.router.events
    .pipe(filter(e => e instanceof NavigationEnd))
    .subscribe(() => this.close());

  toggle(): void {
    if (this.isOpen()) {
      this.close();
      return;
    }
    this.isOpen.set(true);
    this.analytics.logEvent('lookup_open', { source: 'fab' });
  }

  close(): void {
    if (this.isOpen()) this.isOpen.set(false);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.close();
  }

  ngOnDestroy(): void {
    this.navSub.unsubscribe();
  }
}
